// extracted by mini-css-extract-plugin
export default {"wrapperBlocks":"AnswerBlock_wrapperBlocks__RspV1","answerBlock":"AnswerBlock_answerBlock__7q-JU","answerTitles":"AnswerBlock_answerTitles__sRQnd"};